import styled, { css } from 'styled-components';
export const ActivityIndicatorWrapper = styled.div `
  position: absolute;
  top: var(--space-50);
  right: var(--space-50);
`;
const sizeStyleMap = {
    extraSmall: 24,
    small: 32,
    medium: 40,
};
export const Container = styled.div `
  width: ${({ $size }) => sizeStyleMap[$size]}px;
  height: ${({ $size }) => sizeStyleMap[$size]}px;
  outline: none;

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  color: ${({ $color }) => $color || 'var(--icon-primary)'};

  border-radius: var(--radius-brand);

  &:hover {
    background: var(--bg-secondary);

    ${ActivityIndicatorWrapper} {
      border-color: var(--bg-secondary);
    }
  }

  ${({ $variant, theme }) => $variant === 'secondary' &&
    css `
      background: ${theme.automated?.styles?.buttonBackground};
      color: ${theme.automated?.styles?.colorOnBackground};

      &:hover {
        background: ${theme.automated?.styles?.buttonBackgroundHover};
      }
    `};

  ${({ $active }) => $active &&
    css `
      background: var(--bg-secondary);

      ${ActivityIndicatorWrapper} {
        border-color: var(--bg-secondary);
      }
    `};

  ${({ disabled }) => disabled &&
    css `
      background: none !important;
      opacity: 0.4;

      cursor: default;
    `};
`;
